import { Avatar, AvatarFallback, Icon } from "@elaniintc/goes-design-system";
import type { InsolvencyType } from "@/types/entities/insolvencies";
import {
  getInsolvencyableName,
  getInsolvencyType,
  getPersonInitial,
} from "./insolvency.utils";

export const renderComments = (
  comments: { id: string; text: string }[],
): React.ReactNode => {
  if (!comments.length) return "Sin comentarios";
  if (comments.length === 1) return comments[0].text;
  return comments.map((comment) => (
    <div key={comment.id} className="text-sm text-body-quiet py-1">
      - {comment.text}
    </div>
  ));
};

export const renderSubjectAvatar = (
  item: InsolvencyType,
  size: "sm" | "md" = "sm",
) => {
  const type = getInsolvencyType(item);

  if (type === "personal") {
    return (
      <Avatar size={size} shape="circle">
        <AvatarFallback color="action">
          {getPersonInitial(getInsolvencyableName(item))}
        </AvatarFallback>
      </Avatar>
    );
  }

  if (type === "expedient") {
    return (
      <Avatar size={size} shape="circle">
        <AvatarFallback color="action" type="icon">
          <Icon type="fas" name="folder" size="xs" />
        </AvatarFallback>
      </Avatar>
    );
  }

  return (
    <Avatar size={size} shape="circle">
      <AvatarFallback color="action" type="icon">
        <Icon type="fas" name="building" size="xs" />
      </AvatarFallback>
    </Avatar>
  );
};
